<template>
    <td @dblclick="startEditing" :class="{ 'cell-edit':!this.disabled, 'text-white': this.bgColor}" :style="{background:bgColor}">
        <vx-tooltip :delay="tooltipDelay" :text="tooltipText" :tooltipPosition="tooltipPosition">
          <template  v-if="!isEditing">
            {{ value  ? value : '-' }}
          </template>
          <template v-else>
              <vx-input-group >
                  <vs-input type="text" v-model="data.value" @keypress.enter="update"  @keyup.esc="stopEditing" v-mask="'##/##/####'"/>
              </vx-input-group >
          </template>
          </vx-tooltip>
    </td>
</template>

<script>
import moment from 'moment'
export default {
  props:{
    id:{
      required:true
    },
    column:{
      type:String,
      required:true
    },
    value:{
      required:true
    },
    bgColor:{
        type:String,
        required:false,
    },
    tooltipDelay:{
          type:String,
          default:'1.5s'
    },
    tooltipPosition:{
          type:String,
          default:'top'
    },
    tooltipText:{
        type:String,
        default:null
    },
    disabled:{
      type:Boolean
    }
  },
  data:() => ({
    isEditing:false,
    data:{
      id:null,
      column:'',
      value:''
    }
  }),
  methods:{
    startEditing () {
      if (!this.isEditing && this.disabled==false) {
        this.data.id = this.id
        this.data.column = this.column 
        this.data.value = this.value ? this.value : moment().format('L')
        this.isEditing = true
      }   
    },
    stopEditing () {
      this.isEditing = false
    },
    update () {
      this.stopEditing()
      this.data.value = moment(this.data.value, 'MM/DD/YYYY').format('YYYY-MM-DD')
      if (this.value !== this.data.value) {
        this.$emit('update', this.data)
      }
    }
  }
}
</script>

<style>

</style>